import { AuditLog } from '../types/audit';

export const downloadBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export const convertToCSV = (data: AuditLog[]): string => {
  if (data.length === 0) return '';

  const headers = [
    'Request ID',
    'Order ID',
    'Created At',
    'Endpoint',
    'Method',
    'Company ID',
    'Username',
    'Status',
    'Total Time (ms)',
    'AI Time (ms)',
    'Cost ($)',
    'AI Provider',
    'AI Model',
  ];

  const rows = data.map(log => [
    log.requestId,
    log.orderId || '',
    log.createdAt,
    log.endpoint,
    log.method,
    log.companyId || '',
    log.username || '',
    log.responseStatus,
    log.totalTime || '',
    log.aiProcessingTime || '',
    log.estimatedCost || '',
    log.aiProvider || '',
    log.aiModel || '',
  ]);

  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.map(cell => `"${cell}"`).join(',')),
  ].join('\n');

  return csvContent;
};

export const downloadAsCSV = (data: AuditLog[], filename: string = 'audit-logs.csv') => {
  const csv = convertToCSV(data);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  downloadBlob(blob, filename);
};

export const downloadAsJSON = (data: any, filename: string = 'audit-logs.json') => {
  const json = JSON.stringify(data, null, 2);
  const blob = new Blob([json], { type: 'application/json' });
  downloadBlob(blob, filename);
};

export const copyToClipboard = (text: string): Promise<void> => {
  return navigator.clipboard.writeText(text);
};

